import { useEffect, useState } from "react";
import { BadgePhotosUrl } from "../lib/constants";
import silhouette from "../images/silhouette.png";
import { formatRoute } from "../utils/route";

interface BadgePhotoProps {
  alias: string;
  size?: string;
}

export const BadgePhoto = ({ alias, size }: BadgePhotoProps) => {
  const [imgSrc, setImgSrc] = useState(
    formatRoute(BadgePhotosUrl, { queryParams: { uid: alias } }),
  );

  useEffect(() => {
    setImgSrc(formatRoute(BadgePhotosUrl, { queryParams: { uid: alias } }));
  }, [alias]);

  return (
    <img
      src={imgSrc}
      data-testid={`badge-photo-${alias}`}
      alt=""
      style={{
        blockSize: size ?? "3rem",
        borderRadius: "10%",
        border: "2px solid white",
      }}
      onError={() => setImgSrc(silhouette)}
    />
  );
};
